<div class="popup" [class.primary]="primary" [class.secondary]="!primary">
  <div class="popup-content" [class.compare]="data?.ntrips_other">
    <div class="header">
      <h5>
        <span *ngIf="showFrom">{{ 'From' | translate }}</span
        >{{ title }}
      </h5>
      <ng-container *ngIf="compareMode && data.ntrips_other">
        <p class="extra reference">
          {{ data.ntrips | hideZeroValues : '1.0-0' }}
          <small *ngIf="isDensityActive()">
            ({{ keyIndicatorLabel | translate }}/km²)</small
          >
          <span>{{ 'Reference' | translate }}</span>
        </p>
        <p class="extra compared">
          {{ data.ntrips_other | hideZeroValues : '1.0-0' }}
          <small *ngIf="isDensityActive()">
            ({{ keyIndicatorLabel | translate }}/km²)</small
          >
          <span>{{ 'Compared' | translate }}</span>
        </p>
        <p class="extra total">
          {{ getDiff() }} %
          <span>{{ 'difference' | translate }}</span>
        </p>
      </ng-container>
      <ng-container *ngIf="!compareMode || !data.ntrips_other">
        <p
          class="extra"
          [class.nvar]="nvar.key !== data.keyIndicator"
          *ngFor="let nvar of getNvars()"
        >
          {{ nvar.value | hideZeroValues : '1.0-0' }}
          <span>{{ nvar.label | translate }}</span>
        </p>
      </ng-container>
    </div>
    <div *ngIf="showSeparator" class="separator"></div>
    <div *ngFor="let tip of tooltip">
      <p class="extra" *ngIf="data[tip.value]">
        {{ (data[tip.value] | hideZeroValues : '1.2-2') || '--' }}
        <span>{{ tip.label | translate }}</span>
      </p>
    </div>
    <div *ngIf="tooltipExtra?.length" class="separator"></div>
    <div *ngFor="let tip of tooltipExtra" class="tooltip-extra">
      <p class="extra" [attr.class]="tip.class">
        <ng-container *ngIf="tip.value">
          {{ data[tip.value] | hideZeroValues : '1.0-0' }}
        </ng-container>
        <span>{{ tip.label | translate }}</span>
      </p>
    </div>
  </div>
</div>
